export const PLACEHOLDER_MESSAGES = {
  rotate: 'Rotate your screen to play the game!',
  initializing: '',
  location: 'Verifying your location...',
  loading: 'Loading game...',
};

export const POPUP_ERROR_MESSAGES = {
  unsupported:
    'We are sorry about that! We could not identify the selected game. You may try again later.',
  failed: 'Failed to launch casino game.',
  error: 'Failed to launch casino game.',
};
